import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { ordersApi } from '../api/ordersApi'
import { notify } from '@/shared/utils'

export function useOrders(vendorId: string, params: { type?: string; status?: string; page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['vendor-orders', vendorId, params],
    queryFn: () => ordersApi.fetchOrders(vendorId, params),
    enabled: !!vendorId,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
  })
}

export function useOrderDetail(vendorId: string, type: string, orderId: string) {
  return useQuery({
    queryKey: ['vendor-order-detail', vendorId, type, orderId],
    queryFn: () => ordersApi.fetchOrderDetail(vendorId, type, orderId),
    enabled: !!vendorId && !!orderId,
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useUpdateOrderStatus(vendorId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ type, orderId, status, reason }: { type: string; orderId: string; status: string; reason?: string }) =>
      ordersApi.updateOrderStatus(vendorId, type, orderId, status, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['vendor-orders'] })
      queryClient.invalidateQueries({ queryKey: ['vendor-order-detail'] })
      notify.success('Order status updated')
    },
    onError: (err: { message?: string }) => {
      notify.error(err?.message || 'Failed to update order status')
    },
  })
}
